import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LoadingModule } from '@components/loading/index';
import { ToolbarModule } from '@components/toolbar/index';
import { CustomPipeModule } from '@components/custom-pipe/custom-pipe.module';
import { ButtonModule } from '@components/button';
import { ProgressBarModule } from '@components/progress-bar/progress-bar.module';
import { ComparisonSliderModule } from '@shared/comparison-slider/comparison-slider.module';
import { CsIconModule } from '@components/icon';
import { CAudioModule } from '@shared/c-audio/c-audio.module';
import { RouterModule } from '@angular/router';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { ReportFeedbackSheetModule }
  from '@shared/bottom-sheet-layouts/report-feedback-sheet/report-feedback-sheet.module';
import { UserFollowupReportComponent } from './user-followup-report.component';
import {DirectivesModule} from '@directives/directives.module';

@NgModule({
    imports: [
        FormsModule,
        RouterModule.forChild([
            {path: 'report/:id', component: UserFollowupReportComponent},
        ]),
        CommonModule,
        LoadingModule,
        ToolbarModule,
        CustomPipeModule,
        ButtonModule,
        ProgressBarModule,
        ComparisonSliderModule,
        CAudioModule,
        CsIconModule,
        DirectivesModule,
        MatBottomSheetModule,
        ReportFeedbackSheetModule,
    ],
  declarations: [UserFollowupReportComponent],
  exports: [],
})
export class UserFollowupReportModule { }
